import glob from 'glob'
import path from 'path'
import fs from 'fs-extra'
import resolveGlobal from 'resolve-global'

const DEFAULT_DEV_SERVER_PORT = 9091
/* the string bellow will be replaced during build */
// const FURTHER_PATH = "furtherInstallationPath";

let FURTHER_PATH = resolveGlobal.silent('@nasc/furtherjs') || resolveGlobal.silent('furtherjs')

if (!FURTHER_PATH) {
  FURTHER_PATH = process.cwd()
}

// let FURTHER_PATH = resolveGlobal.silent('furtherjs') || process.cwd();
FURTHER_PATH = FURTHER_PATH.replace('dist/index.js', '')
const FURTHER_REF = path.resolve(FURTHER_PATH, 'node_modules') + '/';

export async function thereIsAnyFileMatching (pwd, extensions = [], options = {}) {
  // enforces the argument is an array
  // and adds the list to a Set object
  let patterns = Array.isArray(extensions) ? extensions : [extensions]
  let sPatterns = new Set(patterns)
  let foundPatterns = new Set()
  
  return new Promise((resolve, reject) => {
    let Glob = glob.Glob
    options.silent = options.silent || true
    options.nonull = options.nonull || true
    options.nosort = options.nosort || true
    options.cwd = pwd
    options.path = options.path || ''

    let pattern = `{${options.path}**/*` + patterns.join(`,${options.path}**/*`) +'}'

    delete options.path
    let g = new Glob(pattern, options)
    
    g.on('match', function(path){
      let ext = (path.match(/\.[^\.]+$/) || [])[0]
      foundPatterns.add(ext)

      if (foundPatterns.size === sPatterns.size) {
        // all patterns have been found at least once
        // therefore, we can stop looking for them
        g.abort()
        resolve(Array.from(foundPatterns))
      }
    })
    g.on('end', function(){
      // if reached the end, resolve with the list of the found ones
      resolve(Array.from(foundPatterns))
    })
    g.on('error', function(err){
      reject(err)
    })
  })
}

export async function readFile (file, type='utf8') {
  return new Promise((resolve, reject) => {
    fs.readFile(file, type, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    })
  })
}

export async function fileExists (file) {
  return new Promise(resolve => {
    fs.open(file, 'r', (err, fd) => {
      if (err) {
        if (err.code === 'ENOENT') {
          resolve(false)
        } else {
          resolve (false)
        }
      }
      resolve(fd)
    })
  })
}

function copyFiles (files, from, to, transform) {
  const promisesList = files.map(file => {
    const fromFile = path.resolve(from, file)
    const toFile = path.resolve(to, file)
    if(transform) {
      return new Promise (async (resolve, reject) => {
        let content = await fs.readFile(fromFile, 'utf8')
        try {
          content = transform(content)
          await fs.writeFile(toFile, content)
        } catch (e) {
          reject(`Failed copying:\nFrom: "${fromFile}"\nTo: ${toFile}\n` + e)
        }
        resolve()
      })
    } else {
      // plain copy
      return fs.copyFile(fromFile, toFile)
    }
  })
  return Promise.all(promisesList)
}

function getEntries(SRC_PATH, pattern) {
  const entries = {};
  const rx = new RegExp(`(${SRC_PATH}\/client\/|\.[a-z0-9]+$)`, 'g')

  glob.sync(pattern).forEach((file) => {
    entries[file.replace(rx, '')] = path.join(__dirname, file);
  });

  return entries;
}

function ensureExists (path, delay=0, sync=false) {
  const now = Date.now() / 1000;
  const then = now - delay;

  if (sync) {
    fs.ensureFileSync(path)
    fs.utimesSync(path, then, then)
  } else {
    return new Promise(resolve => {
      fs.ensureFile(path).then(_ => {
        fs.utimesSync(path, then, then)
        resolve()
      })
    })
  }
}

export function killProcessTree (pid, signal) {
  signal   = signal || 'SIGKILL';

  const psTree = require('ps-tree')

  return new Promise((resolve, reject) => {
    psTree(pid, function (err, children) {
        [pid].concat(
            children.map(function (p) {
                return p.PID;
            })
        ).forEach(function (tpid) {
            try { process.kill(tpid, signal) }
            catch (ex) { reject(ex) }
        });
        resolve()
    })
  })
  // var killTree = true;
  // if(killTree) {
  
  // } else {
  //     try { process.kill(pid, signal) }
  //     catch (ex) { }
  //     callback()
  // }
}


export {
  getEntries,
  copyFiles,
  ensureExists,
  DEFAULT_DEV_SERVER_PORT,
  FURTHER_PATH,
  FURTHER_REF
}



// WEBPACK FOOTER //
// ./src/utils.js